"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.StyledWrapper = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["component"];

var _this = void 0;

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Tag = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  (0, _newArrowCheck2["default"])(this, _this);
  var C = _ref.component,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({
    ref: ref
  }, others));
}.bind(void 0));

var StyledWrapper = ( /*#__PURE__*/0, _styledBase["default"])(Tag, {
  target: "ei4c0tt0"
})(process.env.NODE_ENV === "production" ? {
  name: "1h2ruwl",
  styles: "white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
} : {
  name: "1h2ruwl",
  styles: "white-space:nowrap;overflow:hidden;text-overflow:ellipsis;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNd0MiLCJmaWxlIjoiaW5kZXguanN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyogZXNsaW50LWRpc2FibGUgcmVhY3QvcHJvcC10eXBlcyAqL1xuaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCI7XG5cbmNvbnN0IFRhZyA9IFJlYWN0LmZvcndhcmRSZWYoKHsgY29tcG9uZW50OiBDLCAuLi5vdGhlcnMgfSwgcmVmKSA9PiA8QyByZWY9e3JlZn0gey4uLm90aGVyc30gLz4pO1xuXG5leHBvcnQgY29uc3QgU3R5bGVkV3JhcHBlciA9IHN0eWxlZChUYWcpYFxuICAgIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbmA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
exports.StyledWrapper = StyledWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/TextEllipsis/style/index.js
// module id = 2117
// module chunks = 6 7 17 18